import { ImgHTMLAttributes } from 'react';
import logo from '@app/assets/images/favicon.svg';
import { useTranslation } from 'react-i18next';

export default function AppLogoIcon(props: ImgHTMLAttributes<HTMLImageElement>) {
    const { t } = useTranslation();
    return (
        <img src={logo} alt={t('common.accessibility-extra.app-logo')} {...props} />
    );
}
